import { render, staticRenderFns } from "./flow-chart.vue?vue&type=template&id=495cf8be&scoped=true"
import script from "./flow-chart.vue?vue&type=script&lang=js"
export * from "./flow-chart.vue?vue&type=script&lang=js"
import style0 from "./flow-chart.vue?vue&type=style&index=0&id=495cf8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495cf8be",
  null
  
)

export default component.exports